import { queryOptions } from "@tanstack/react-query";
import type { PublicFaqCategory } from "@/types/faq";
import { apiUrl } from "@/lib/api-url";

export interface PublicFaqEnvelope {
  categories: PublicFaqCategory[];
}

export const publicFaqQuery = queryOptions({
  queryKey: ["faq", "public"] as const,
  queryFn: async (): Promise<PublicFaqEnvelope> => {
    const res = await fetch(apiUrl("/api/faq"));
    if (!res.ok) throw new Error("Failed to fetch FAQ");
    return res.json();
  },
});
